module.exports = __webpack_public_path__ + "static/media/content-divider-gray.8910663a.png";